module.exports = __webpack_public_path__ + "img/1723535642233-WhatsApp Image 2024-08-13 at 15.53.05.jpeg.258ce55a.webp";